import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import moment from 'moment'
import 'moment/locale/ko'
// import { signout } from '../utils/signout'
import { useAxios } from '../utils/useAxios'

// constants
import * as constants from '../globals/constants'

//images
import Warning from '../assets/image/warning/ic-warning.svg'

const Error = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { fetchData, data } = useAxios()
  console.log('error navLink', location?.state?.navLink)

  const signout = (e) => {
    e.preventDefault()
    fetchData(constants.API.SIGN_OUT, 'POST')
    localStorage.removeItem('user')
    localStorage.removeItem('isNewNotice')
    localStorage.removeItem('happyorderYn')
    localStorage.removeItem('closedDay')
    localStorage.removeItem('shopHoursStart')
    localStorage.removeItem('shopHoursEnd')
    localStorage.removeItem('sessionAlert')
    navigate('/signin', { replace: true })
    window.location.reload()
  }
  const redirectHome = (e) => {
    e.preventDefault()
    navigate('/')
    window.location.reload()
  }

  return (
    <Overlay>
      <img src={Warning} />
      <Title>현재 페이지를 불러올 수 없습니다.</Title>
      <Msg>
        인터넷 접속이 불안정하거나 갑자기 접속이 몰렸을 수 있으니 잠시 후 다시
        시도해주세요!
      </Msg>
      {location?.state?.navLink ? (
        <HomeRedirect onClick={signout}>홈으로 가기</HomeRedirect>
      ) : (
        // <HomeRedirect onClick={() => navigate('/', { replace: true })}>
        <HomeRedirect onClick={redirectHome}>홈으로 가기</HomeRedirect>
      )}
      {/* <HomeRedirect onClick={() => navigate('/', { replace: true })}>
        홈으로 가기
      </HomeRedirect> */}
    </Overlay>
  )
}

export default Error

const WarningImg = styled.img`
  width: 68px;
  height: 68px;
  margin: 0 212px 18px;
  object-fit: contain;
  @media ${(props) => props.theme.mobile} {
    margin: 0 88px 18px;
  }
`

const Overlay = styled.div`
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  z-index: 1000;
  color: black;
  padding: 20px;
  border-radius: 10px;
`

const Title = styled.div`
  width: 424px;
  height: 44px;
  margin: 18px 34px;
  object-fit: contain;
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  color: #00a61c;
  @media ${(props) => props.theme.mobile} {
    width: 244px;
    height: 84px;
    margin: 18px 0 14px;
    object-fit: contain;
    font-size: 30px;
    line-height: 1.33;
  }
`

const Msg = styled.div`
  width: 492px;
  height: 58px;
  margin: 18px 0 70px;
  object-fit: contain;
  font-size: 20px;
  text-align: center;
  color: #8a8a8a;
  @media ${(props) => props.theme.mobile} {
    width: 206px;
    height: 72px;
    margin: 14px 19px 26px;
    font-size: 16px;
  }
`

const HomeRedirect = styled.div`
  width: 96px;
  height: 29px;
  margin: 70px 198px 0;
  object-fit: contain;
  font-family: NotoSansKR;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  color: #8a8a8a;
  text-decoration: underline;
  @media ${(props) => props.theme.mobile} {
    width: 78px;
    height: 24px;
    margin: 26px 83px 0;
    font-size: 16px;
  }
`
